import React, { useEffect, useState } from 'react'
import { CButton, CFormInput } from '@coreui/react'
import CopyLogo from '../../assets/copy-logo.svg'
import CheckIcon from '../../assets/check-icon-copy.svg'
const ClipboardCopy = ({ copyText, css, inputFontSize = '16px' }) => {
  const [isCopied, setIsCopied] = useState(false)
  async function copyTextToClipboard(text) {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text)
    } else {
      return document.execCommand('copy', true, text)
    }
  }

  useEffect(() => {
    if (isCopied) {
      setTimeout(() => setIsCopied(false), 2000)
    }
  }, [isCopied])

  const handleCopyClick = () => {
    copyTextToClipboard(copyText)
      .then(() => {})
      .catch((err) => {
        console.log(err)
      })
    setIsCopied(true)
  }

  return (
    <div className={`position-relative overflow-hidden d-flex ${css}`}>
      <CFormInput type="text" style={{ fontSize: inputFontSize }} value={copyText} readOnly />
      <CButton
        style={{
          fontSize: '13px',
          borderRadius: '0px',
          borderTopRightRadius: '4px',
          borderBottomRightRadius: '4px',
          background: isCopied ? '#0b8d1d' : '#20211c',
          borderColor: isCopied ? '#0b8d1d' : 'black',
          width: '122px',
        }}
        className={`position-absolute h-100 end-0  text-white `}
        onClick={handleCopyClick}
      >
        {isCopied ? 'Copied' : 'Copy'}

        <img src={isCopied ? CheckIcon : CopyLogo} alt="CopyLogo" className="ml-2" />
      </CButton>
    </div>
  )
}

export default ClipboardCopy
